import services from "./index";
import httpcommon from "./httpcommon";

class Buymedicine {
    postDataLogin(payload) {
        return httpcommon.post("order/getPurchaseToken", payload)
    }

};
export default new Buymedicine();